import { Text, TextColor, TextSize, TextWeight } from '@vizit/atoms';
import React from 'react';
import { AssetContext } from './asset.context-provider';

interface AssetLabelProps {
  children: React.ReactNode;
  /**
   * Optional class name forwarded to the underlying text, e.g. `truncate` to
   * keep a long label on a single line.
   * @optional
   */
  className?: string;
}

function AssetLabel({ children, className }: AssetLabelProps) {
  const { onLabelMount } = React.useContext(AssetContext);

  // The label sits above the image inside the asset, so the asset has to know
  // it is there to keep the hover action buttons anchored to the image.
  React.useEffect(() => {
    onLabelMount?.(true);

    return () => {
      onLabelMount?.(false);
    };
  }, [onLabelMount]);

  return (
    <Text size={TextSize.Xs} weight={TextWeight.Medium} color={TextColor.Tertiary} className={className}>
      {children}
    </Text>
  );
}

export type { AssetLabelProps };
export { AssetLabel };
